import ContentFilterValues from "src/model/ContentFilter";
import { allKeys } from "./keys";

export const isFilterEmptyFunc = (filter: ContentFilterValues): boolean => {
  // Only check keys that are in ContentKeys + NutritionKeys (allKeys)
  return allKeys.every((key) => {
    const value = filter[key];

    if (Array.isArray(value)) {
      // If array and non-empty → filter NOT empty
      return value.length === 0;
    }

    if (typeof value === "string") {
      // If string and non-empty (after trimming) → filter NOT empty
      return value.trim() === "";
    }

    // If value is undefined or something else, treat as empty (true)
    return true;
  });
};
